export default "__VITE_ASSET__7SBEmyMp__"